var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:[_vm.displayClass, { ellipsis: _vm.ellipsis }]},[_vm._v(_vm._s(_vm.serviceIdText))])
}
var staticRenderFns = []

export { render, staticRenderFns }